import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import classNames from 'classnames';


export default function CompanyLink({ company, className, children }) {
  if (!company || _.isEmpty(company)) return null;

  return (
    <Link to={`/companies/${company.id}`} className={classNames('company-link', className)}>
      {children || company.name}
    </Link>
  );
}

CompanyLink.propTypes = {
  company: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
};
